var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"hub page"},[(_vm.currentUser.type === 'student')?_c('student-dashboard',{attrs:{"showScheduleModal":_vm.showScheduleModal}}):(_vm.currentUser.type === 'teacher')?_c('teacher-dashboard'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }